<div mat-dialog-title style="position: relative;">
    <p style="font-weight: bold; background-color: #efefef; color: #c89d07;padding: 8px;margin-top: -8px;
    margin-left: -24px;margin-right: -24px;">
        Customers left - Update and Proceed
    </p>
</div>

<app-grid *ngIf="customers.length > 0" (reloadCustomersList)="reloadCustomers($event)" [data]="customers" [type]="gridType" [defaultColumns]="headers" 
[matchedHeaders]="matchedHeaders"></app-grid>